import React, { createContext, useContext, useState } from 'react';
import Box from '@mui/material/Box';
import SidebarMenu from "./SidebarMenu";  // ✅ 정확한 파일명과 일치
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import "../css/lnb.css";
import { WeatherPaper } from 'pages/components/WeatherPaper';
import { SwItsAvgSpeedTotalProvider, SwItsAvgSpeedTotalInfo } from 'pages/components/dashboard/SwItsGetAvgSpeed';
import { SwItsTrafficTotalProvider, SwItsTrafficTotalInfo, SwItsInOutTotalInfo } from 'pages/components/dashboard/SwitsTrafficTotalData';
import { SwItsRoadTrafficTotalProvider, SwItsRoadTrafficRight, SwItsRoadTrafficGrid } from 'pages/components/dashboard/SwItsGetTrafficRoadSpeed';
import { SwItsGetSmtTrfTotalProvider, SwItsGetSmtTrfTotalInfo } from 'pages/components/dashboard/SwItsGetSmtTrf';
import { SwItsTrafficInOutSumInfo, SwItsTrafficInOutProvider, SwItsInOutHeaderTotalInfo } from 'pages/components/dashboard/SwItsTrafficInOutView';

import { useTranslation } from 'react-i18next';
const TrafficInOutTabContext = createContext();

export const TrafficInOutTabProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState('in');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <TrafficInOutTabContext.Provider value={{ activeTab, handleTabClick }}>
            {children}
        </TrafficInOutTabContext.Provider>
    );
};

export const useTrafficInOutTab = () => useContext(TrafficInOutTabContext);

export default function RoadTrafficViewD() {
    React.useEffect(() => {

    }, []);
    const { t, i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ko' ? 'en' : 'ko';
        i18n.changeLanguage(newLang);
    };

    return (<Box sx={{ height: '100%', width: '100%', }}>
        <TrafficInOutTabProvider>
            <div className="dashboard container flx a_center">
                <SidebarMenu />
                <div className="ctrlMain">
                    <div className="mainTit flx j_spc_btw a_center">
                        <div className="titBox">
                            <p
                                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                                onClick={toggleLanguage}
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                            >
                                {t('subtitle')}
                            </p>
                            <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                                {t('mainTitle2')}
                            </p>
                        </div>
                        <div className="weatherWrap flx a_center j_spc_btw">
                            <WeatherPaper sx={{ width: '300px' }} />
                        </div>
                    </div>
                    <div className="mainInfo L_lr gap60">{/*메인박스*/}
                        <div className='L_2m inner'>
                            <div className='titWrap flx j_spc_btw'>
                                 <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-03)' }}>{t('AverageTravelSpeed')}
                                    {/* <span className='en'>Average Travel Speed</span> */}
                                </h2>
                            </div>
                            <div className='spdConts'>
                                <SwItsRoadTrafficTotalProvider>
                                    <div className='top flx a_center j_spc_btw'>
                                        <SwItsAvgSpeedTotalProvider>
                                            <div className='left innerBg flx flx_col a_center j_center'>
                                                <SwItsAvgSpeedTotalInfo showRangeValue={true} />
                                            </div>
                                        </SwItsAvgSpeedTotalProvider>
                                        <SwItsRoadTrafficRight />
                                    </div>
                                    <SwItsRoadTrafficGrid />
                                </SwItsRoadTrafficTotalProvider>
                            </div>
                        </div>
                        <div className='L_2m inner'>
                            <div className='titWrap flx j_spc_btw'>
                                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('Traffic Volume')}
                                </h2>
                            </div>
                            <div className='trfConts'>
                                <SwItsTrafficTotalProvider>
                                    <SwItsTrafficInOutProvider pageType="dashBoard">
                                        <div className='top flx a_center j_spc_btw'>
                                            <div className='left innerBg flx flx_col a_center j_center'>
                                                <SwItsTrafficTotalInfo showMonthValue={true} />
                                            </div>
                                            <SwItsInOutHeaderTotalInfo />
                                        </div>
                                    </SwItsTrafficInOutProvider>
                                </SwItsTrafficTotalProvider>
                                <div className='grid flx j_spc_btw'>
                                    <SwItsGetSmtTrfTotalProvider>
                                        <SwItsGetSmtTrfTotalInfo />
                                    </SwItsGetSmtTrfTotalProvider>
                                    <div className='inOutGrid flx flx_col'>
                                        <div className='gridTitLi flx a_center j_spc_btw'>
                                            <p className='rdNm'>유출입</p>
                                            <p className='ovlyDt'>현재교통량</p>
                                        </div>
                                        <SwItsTrafficInOutProvider pageType="dashBoard">
                                            <div className='gridBox cst_scroll'>
                                                <SwItsTrafficInOutSumInfo />
                                            </div>
                                        </SwItsTrafficInOutProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TrafficInOutTabProvider>
    </Box>
    )
}